import LinearProgress, {
  linearProgressClasses,
} from '@mui/material/LinearProgress';
import { Box } from '@mui/system';
import styled from '@mui/system/styled';
import CTypography from 'components/CTypography';

export const ProjectIcon = styled(Box)({
  width: '38px',
  height: '38px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '0 0 38px',
  borderRadius: '6px',
  background: '#EBEAFF',
  '& svg': {
    fontSize: '18px',
  },
  '& path': {
    fill: 'none',
    stroke: '#4E48FA',
  },
});

export const ProjectProgrss = styled(CTypography)({
  fontSize: 14,
  color: '#000000',
  fontWeight: 700,
  lineHeight: '19.92px',
  maxWidth: '100%',
  width: 200,
  marginBottom: 0,
  borderRadius: 6,
  border: '1px solid #E0E0E0',
  padding: '6px 10px',
  boxSizing: 'content-box',
});

export const BorderLinearProgress = styled(LinearProgress)(
  ({ theme, progressBarBg, progressBarFg }) => {
    return {
      height: 6,
      borderRadius: 6,
      marginTop: 6,
      [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: progressBarBg,
      },
      [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 6,
        backgroundColor: `${progressBarFg} !important`,
      },
    };
  },
);
